import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-upgrade-prompt',
  template: `
    <div class="up__prompt" *ngIf="message">
      
      <!-- Icon -->
      <div class="up__icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </div>

      <!-- Content -->
      <div class="up__content">
        <p class="up__message">{{ message }}</p>

        <div class="up__actions">
          <button class="up__btn" (click)="upgrade()">
            Upgrade Plan
          </button>

          <button class="up__dismiss" (click)="dismiss()">
            Dismiss
          </button>
        </div>
      </div>

    </div>
  `,
  styles: [`
    .up__prompt {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      background: rgba(43,176,166,0.06);
      border: 1.5px solid rgba(43,176,166,0.25);
      border-radius: 10px;
      padding: 14px 16px;
      margin-bottom: 16px;
    }

    .up__icon {
      width: 32px; height: 32px;
      background: rgba(43,176,166,0.12);
      border-radius: 8px;
      display: flex; align-items: center; justify-content: center;
      color: var(--fo-teal-dark);
      flex-shrink: 0;
    }

    .up__content {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;
    }

    .up__message {
      font-size: 13px;
      color: var(--fo-text);
      margin: 0;
    }

    .up__actions {
      display: flex;
      gap: 8px;
      align-items: center;
    }

    .up__btn {
      background: var(--fo-teal);
      color: white;
      border: none;
      padding: 7px 16px;
      border-radius: 7px;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      font-family: 'DM Sans', sans-serif;
    }

    .up__btn:hover {
      background: var(--fo-teal-dark);
    }

    .up__dismiss {
      background: transparent;
      border: none;
      color: #888;
      font-size: 12px;
      cursor: pointer;
    }

    .up__dismiss:hover {
      color: #444;
    }
  `]
})
export class UpgradePromptComponent {

  @Input() message = '';

  constructor(private router: Router) {}

  upgrade(): void {
    this.router.navigate(['/pricing']);
  }

  dismiss(): void {
    this.message = '';
  }
}